import { render, staticRenderFns } from "./SectionHeroAbout.vue?vue&type=template&id=08857323&scoped=true"
import script from "./SectionHeroAbout.vue?vue&type=script&lang=js"
export * from "./SectionHeroAbout.vue?vue&type=script&lang=js"
import style0 from "./SectionHeroAbout.vue?vue&type=style&index=0&id=08857323&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08857323",
  null
  
)

export default component.exports